//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ["detailData", "detailList"],
  data: function data() {
    return {};
  },
  methods: {
    closeModal: function closeModal() {
      this.detailData.state = false;
    }
  }
};